import { Injectable } from '@nestjs/common';
import { Repository, Raw, getConnection, getManager, Not, IsNull, Any } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse, FgStatusEnum, GlobalStatus, HarvestTypes, OperationTypeEnum, ProductionTypeEnum, UnitRequest } from '@gtpl/shared-models/common-models';
import { GrnRequest } from './dto/raw-material-grn.request';
import { Grn } from './raw-material-grn.entity';
import { GrnDTO } from './dto/raw-material-grn.dto';
import { GrnAdapter } from './dto/raw-material-grn.adapter';
import { GrnResponseModel } from 'libs/shared-models/raw-material-procurement/src/lib/raw-material-grn/raw-material-response-model';
import { AllGrnResponseModel } from 'libs/shared-models/raw-material-procurement/src/lib/raw-material-grn/all-raw-material-grn-response-model';
import { BomIdRequest, saleOrder, SaleOrderItemsRequest, SaleOrderService } from '@gtpl/shared-services/sale-management';
import { SaleOrderDropDownDto, SaleOrderDropDownResponseModel, SoProductionDTO } from '@gtpl/shared-models/sale-management';
import { HLpercentagesService, SuppliersService, UnitcodeService, VehicleService } from '@gtpl/shared-services/masters';
import { CommonResponse, FarmerModel, FarmerRequest, HlPercentageRangeRequest, MasterInfoFromIndentRequest, MasterInfoFromIndentResponse, PlantIdRequest, UnitTypeEnum } from '@gtpl/shared-models/masters';
import { GrnData, GrnStatusUpdate, GrnVehicleInfo, LotCodesDTO, LotCodesResponseModel, RmGrnResponseModel, RMVehicleInfoResponse } from '@gtpl/shared-models/raw-material-procurement';
import { IndentService } from '@gtpl/shared-services/raw-material-procurement';
import { LotCodesRequest } from './dto/lot-codes.request';
import { GrnInformationDto, LotCodeData, LotCodeOpsData, ProdData, ProdInvData, ProductionLogDto } from '@gtpl/shared-models/production-management';
import { LotCodeOpsService, ProdInvService, ProductionInventoryService, ProdlogService } from '@gtpl/shared-services/production';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { GrnRepository } from './grn-repository';
import { GrnItemRepository } from './grn-item-repository';
import { ReceivedBoxes } from './dto/received-boxes.request';
import { VehicleAssignmentService } from '@gtpl/shared-services/transportation';
import { RmGrnDetailsDto } from './dto/rm-grn-details.dto';
import appSettings from 'apps/services/config';
import { GrnItems } from './raw-material-grn-items.entity';
import { isNotEmpty } from 'class-validator';
import { RmGrnPlantRequest } from './dto/rm-grn-plants-request';
import { RMGrnItemIdReq } from './dto/grn-item-id.request';
import { LotNumberRequest } from './dto/lot-number.request';
import { GrnAbstractRequest } from './dto/grn-abstract.request';
import { RmActualCountDto } from './dto/rm-actual-count.dto';
import moment from 'moment';
import { ApiProperty } from '@nestjs/swagger';
const mastersSuppluierTable = appSettings.masters_db + '.suppliers';
const mastersFarmsTable = appSettings.masters_db + '.farms';
const mastersProductsTable = appSettings.masters_db + '.products';
const mastersEmployeeTable = appSettings.masters_db + '.employee_details';
const rmGrnTable = appSettings.rm_procure_db + '.grn';
const rmGrnItemsTable = appSettings.rm_procure_db + '.grn_items';
const rmIndentTable = appSettings.rm_procure_db + '.indent';
const rmVIInspection = appSettings.rm_procure_db + '.rm_vehicle_inspection';
const rmIndentItemsTable = appSettings.rm_procure_db + '.indent_items';
const salesSoTable = appSettings.sales_db + '.sale_order';
const salesInvTable = appSettings.sales_db + '.so_invoice_details';
const rmVehicleAssignment = appSettings.transport_db + '.vehicle_assignment';
const harvesting = appSettings.rm_procure_db + '.harvest_report';



@Injectable()
export class RawMaterialGrnService {
  constructor(
    @InjectRepository(Grn)
    private grnRepository: Repository<Grn>,
    @InjectRepository(GrnItems)
    private grnItemRepository: Repository<GrnItems>,
    private grnAdapter: GrnAdapter,
    private saleOrderService: SaleOrderService,
    private hlPerService: HLpercentagesService,
    private supplierService: SuppliersService,
    private indentService: IndentService,
    private unitcodeService: UnitcodeService,
    private prodInvService: ProductionInventoryService,
    private lotCodeOpsService: LotCodeOpsService,
    private prodLogService: ProdlogService,
    private vehicleAssignmentService: VehicleAssignmentService,
    private vehicleService: VehicleService,
    private harvestreportService: IndentService,
    private unitCodesService: UnitcodeService,

  ) { }


  async getGrnDetailsWithoutRelations(remarks) {
    // tslint:disable-next-line: typedef
    const grnResponse = await this.grnItemRepository.findOne({
      where: { remarks: remarks },
    });
    if (grnResponse) {
      return grnResponse;
    } else {
      return null;
    }
  }



  async createGrn(grnDto: RmGrnDetailsDto, isUpdate: boolean): Promise<RmGrnResponseModel> {
    // console.log("grnDto req");
    // console.log(grnDto);

    const manager = new GenericTransactionManager();
    const queryManger = getManager()

    try {
      let toDate = 0;
      let refNo;
      let grnItemRefNo;
      let totalGrnItems;


      if (!isUpdate) {
        console.log(grnDto, 'oooooooohh')
        let unitCode;

        if (grnDto) {
          if (grnDto.plantId === 1) {
            unitCode = 'U1'
          }
          if (grnDto.plantId === 2) {
            unitCode = 'U2'
          }
          if (grnDto.plantId === 3) {
            unitCode = 'KKD'
          }

        }
        let today = new Date();
        let CurrentYear = today.getFullYear();
        let CurrentMonth = today.getMonth();
        let fromDate = 0;
        let totalGrn = await this.grnRepository.count();
        // totalGrnItems = await this.grnItemRepository.count();
        if (!isUpdate) {
          if (CurrentMonth < 4) {
            fromDate = (CurrentYear);
            toDate = (CurrentYear);
          } else {
            fromDate = (CurrentYear);
            toDate = (CurrentYear + 1);
          }

        }

        totalGrn = totalGrn + 1;

        refNo = totalGrn + "";
        while (refNo.length < 4) refNo = "0" + refNo;
        const currentFinancialYear = "G" + (toDate.toString().substr(-2)) + "/" + (grnDto.grnItemsInfo)[0].farmerCode + "/" + refNo;
        grnDto.grnNumber = currentFinancialYear;
        // const lotNo = "LOT" + "-" + (grnDto.plantId === 1 ? 'U1' : grnDto.plantId === 2 ? 'U2' : grnDto.plantId === 3 ? 'KKD' : '') + "/" + (toDate.toString().substr(-2)) + '/' + (today.getMonth() + 1) + "/" + refNo;
        // grnDto.lotNumber = lotNo;
      }
      // monthlyRefNo logic
      const month = moment().month()
      const year = moment().year()
      const getMaxId = `select max(ref_no) as ref from ${appSettings.rm_procure_db}.grn_items gi where YEAR(created_at) = ${year} and MONTH(gi.created_at) =  ${month + 1} `
      const result = await queryManger.query(getMaxId)
      console.log(result)

      for (const [index, item] of grnDto.grnItemsInfo.entries()) {
        //assigning sale order to the grn based on its count

        // const getSoSoItem = `select rb.sale_order_id as saleOrderId,rb.sale_order_item_id as saleOrderItemId from ${appSettings.sales_db}.rm_bom_log rb 
        // left join ${appSettings.sales_db}.so_invoice_details sinv ON  sinv.sale_order_id = rb.sale_order_id
        // where rb.min_count<= ${item.count} AND rb.max_count >= ${item.count} AND  sinv.act_edl_date between DATE('${moment().format('YYYY-MM-DD')}') and DATE('${moment(nextMonth).format('YYYY-MM-DD')}') order by sinv.act_edl_date asc `
        // const data = await queryManger.query(getSoSoItem)
        // if(data.length){
        //   item.saleOrderId = data[0].saleOrderId
        //   item.saleOrderItemId = data[0].saleOrderItemId 
        // }
        if (!isUpdate) {
          const checkForDuplicate = await this.getGrnDetailsWithoutRelations(item.remarks)
          if (checkForDuplicate) {
            throw new CommonResponse(false, 11104, 'Plant LotNumber Already exists');

          }
        }

        if (result && result.length) {
          const maxref = Number(result[0].ref) + (index + 1)
          item.monthlyRefNo = maxref
          console.log(item.monthlyRefNo)
        } else {
          item.monthlyRefNo = ((index) + 1)
          console.log('else',item.monthlyRefNo)

        }
      }

      const convertedGrnEntity: Grn = this.grnAdapter.convertDtoToEntity(grnDto, isUpdate, toDate, refNo, totalGrnItems);
      manager.startTransaction()
      if (isUpdate) {

        // const soItemReq:SaleOrderItemsRequest={
        //   saleOrderItemId: grnDto.saleOrderItemId
        // }
        // const soItemDetails =await this.saleOrderService.getSaleOrderItemDetailsBySoItemId(soItemReq)
        // const hlPercentagedata: any = await this.hlPerService.getHlPercentageByRange(
        //   new HlPercentageRangeRequest(
        //     soItemDetails.data.maxGrade,
        //   )
        // );
        // const trtmntPer = await soItemDetails.data.finalPercentage;

        // const opQty = await (grnDto.quantity)*(hlPercentagedata/100)*(trtmntPer/100)
        // console.log('------'+opQty)
        for (const item of grnDto.grnItemsInfo) {
          const soProductionDto = await new SoProductionDTO();
          soProductionDto.saleOrderId = item.saleOrderId;
          soProductionDto.saleOrderItemId = item.saleOrderItemId;
          soProductionDto.lotNumber = item.lotNumber;
          soProductionDto.inputQuantity = item.quantity;
          soProductionDto.type = ProductionTypeEnum.GRN;
          soProductionDto.outputQuantity = 0;
          soProductionDto.createdUser = item.createdUser;
          soProductionDto.updatedUser = item.updatedUser;
          // soProductionDto.versionFlag = item.versionFlag;
          const soProduction = await this.saleOrderService.createSoProduction(soProductionDto)


        }

        // const prodInvDto = await new ProdData();
        // //  prodInvDto.grnNumber = grnDto.grnNumber;
        //  prodInvDto.lotNumber = grnDto.lotNumber;
        //  prodInvDto.saleOrderId = grnDto.saleOrderId;
        //  prodInvDto.saleOrderItemId= grnDto.saleOrderItemId;
        //  prodInvDto.physicalQuantity = grnDto.quantity;
        //  prodInvDto.inputGrade = grnDto.count;
        //  prodInvDto.boxes = grnDto.boxes;
        //  prodInvDto.plantId = grnDto.plantId;
        //  prodInvDto.subPlantId = grnDto.subPlantId;
        //  prodInvDto.weighmentReq = GlobalStatus.NO;
        //  prodInvDto.operation = OperationTypeEnum.BE_HEADING;
        //  prodInvDto.nextOperation = OperationTypeEnum.GRADING;
        //  prodInvDto.status = FgStatusEnum.OPEN;
        //  prodInvDto.createdUser = grnDto.createdUser;

        //    const prodInv = await this.prodInvService.createProdInv(prodInvDto)


        // const lotCodeOpsDto = await new LotCodeOpsData();
        //   lotCodeOpsDto.grnDate = grnDto.grnDate;
        //   lotCodeOpsDto.indentId = grnDto.indentId;
        //   lotCodeOpsDto.grnNumber = grnDto.grnNumber;
        //   lotCodeOpsDto.lotNumber = grnDto.lotNumber;
        //   lotCodeOpsDto.saleOrderId = grnDto.saleOrderId;
        //   lotCodeOpsDto.saleOrderItemId = grnDto.saleOrderItemId;
        //   lotCodeOpsDto.supplierType = grnDto.supplierType;
        //   lotCodeOpsDto.farmer = grnDto.farmer;
        //   lotCodeOpsDto.farmerCode = grnDto.farmerCode;
        //   lotCodeOpsDto.count = grnDto.count;
        //   lotCodeOpsDto.price = grnDto.price;
        //   lotCodeOpsDto.boxes = grnDto.boxes;
        //   lotCodeOpsDto.plantId = grnDto.plantId;
        //   lotCodeOpsDto.subPlantId = grnDto.subPlantId;
        //   lotCodeOpsDto.createdAt = grnDto.createdAt;
        //   lotCodeOpsDto.createdUser = grnDto.createdUser;

        //    const lotCodeOps = await this.lotCodeOpsService.createLotCodeOps(lotCodeOpsDto)

      }

      const savedGrnEntity: Grn = await this.grnRepository.save(
        convertedGrnEntity
      );
      // const savedGrnDto: GrnDTO = this.grnAdapter.convertEntityToDto(convertedGrnEntity);
      // console.log(savedStateDto);

      if (savedGrnEntity) {
        // generating resposnse

        const response = new RmGrnResponseModel(true, 1, isUpdate ? 'Grn Updated Successfully' : 'Grn Created Successfully');

        const grnStatus: GrnStatusUpdate = {
          indentId: grnDto.indentId,
          grnCompleted: true,
        }
        // update sale tracker status
        const grnStatusUpdate = await this.indentService.updateGrnCompletedStatus(grnStatus);

        if (isUpdate && grnDto.harvestType == HarvestTypes.Re_Weighment) {
          for (const items of savedGrnEntity.grnItemsInfo) {
            console.log(savedGrnEntity, items)
            if (items.saleOrderId) {
              const grnInfo: any = {};
              grnInfo.receivedBoxes = items.receivedBoxes
              grnInfo.grnDate = savedGrnEntity.grnDate;
              grnInfo.indentId = savedGrnEntity.indentId;
              grnInfo.grnNumber = grnDto.grnNumber;
              grnInfo.saleOrderId = items.saleOrderId;
              grnInfo.saleOrderItemId = items.saleOrderItemId;
              grnInfo.supplierType = grnDto.supplierType;
              grnInfo.farmer = items.farmer;
              grnInfo.farmerCode = items.farmerCode;
              grnInfo.count = items.count;
              grnInfo.quantity = items.quantity;
              grnInfo.price = items.price;
              grnInfo.boxes = items.receivedBoxes;
              grnInfo.plantId = savedGrnEntity.plantId;
              grnInfo.remarks = items.remarks
              grnInfo.refNo = items.monthlyRefNo
              grnInfo.subPlantId = savedGrnEntity.subPlantId;
              grnInfo.createdUser = items.updatedUser;
              grnInfo.grnItemId = items.grnItemId
              await this.assignToRM(grnInfo, false)
            }
          }
        }

        if (grnStatusUpdate.status) {
          manager.completeTransaction()
          return response
        } else {
          manager.releaseTransaction()
          return new RmGrnResponseModel(false, 0, 'something went wrong', undefined)
        }
      } else {
        manager.releaseTransaction()
        //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
        throw new ErrorResponse(11106, 'Grn saved but issue while transforming into DTO');
      }
    } catch (error) {
      manager.releaseTransaction()
      console.log(error)
      // when error occures while saving the data , the execution will come to catch block.
      // tslint:disable-next-line: typedef

      return error;
    }
  }



  async getAllGrnData(req?: UnitRequest): Promise<CommonResponse> {
    const manager = getManager();
    const query = 'select plant_type from ' + appSettings.masters_db + '.unitcodes where unit_code_id=' + req.unitId;
    const result = await manager.query(query);
    let grnQuery = `SELECT i.indent_by as employeeId,e.employee_name as indentPerson,i.grn_completed as grnCompleted,g.grn_id as grnId,g.grn_date as grnDate,g.grn_number as grnNumber,i.assign_lead_1 as assignLead1,i.supplier_type as supplierType,i.vehicle_assigned as vehicleAssigned,i.assign_lead_2 as assignLead12,i.commission,i.commission_type as commissionType,i.created_user as createdUser,i.grn_completed as grnCompleted,i.harvesting_date as harvestingDate,i.harvesting_time as harvestingTime,i.indent_code as indentCode,i.indent_date as indentDate,i.indent_id as indentId,i.indent_code as indentNumber,g.plant_id as plantId,g.sub_plant_id as subPlantId,uc.unit_code_id AS unitId ,uc.unit_name as unit, gi.assign_to_rm as assignToRm,indent_by as indentBy,s.name as supplier,e.employee_name as indentPerson FROM ` + rmGrnTable + ` g
    LEFT JOIN `+ rmIndentTable + ` i ON i.indent_id=g.indent_no 
    LEFT JOIN `+ appSettings.rm_procure_db + `.indent_items ii on ii.indent_id = i.indent_id
    LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id=g.plant_id 
    LEFT JOIN `+ appSettings.rm_procure_db + `.grn_items gi ON gi.grn_id=g.grn_id 
    LEFT JOIN `+ appSettings.masters_db + `.suppliers s ON s.supplier_id = ii.farmer
    LEFT JOIN `+ appSettings.masters_db + `.employee_details e on e.employee_id = i.indent_by where g.grn_id >0`
    if (result[0].plant_type == UnitTypeEnum.SUB_PLANT) {
      grnQuery += " AND g.sub_plant_id=" + req.unitId;
    }
    if (result[0].plant_type == UnitTypeEnum.PLANT) {
      grnQuery += " AND g.plant_id=" + req.unitId + ' and g.sub_plant_id = 0';
    }
    grnQuery = grnQuery + ` group by ii.indent_id ORDER By g.grn_date DESC`;
    const grnData = await manager.query(grnQuery);
    return new CommonResponse(true, 5555, 'GRN data retrieved', grnData)
  }

  async getTraceabilityCodeForLot(req: LotNumberRequest) {
    const manager = getManager();
    const query = `SELECT  gi.farmer as supplierId, gi.lot_number as lotNumber, CASE WHEN gi.broker > 0 THEN CONCAT_WS(", ", msb.street, msb.apartment, msb.city, msb.state, msb.district, msb.postal_code) ELSE CONCAT_WS(", ",ms.street, ms.apartment, ms.city, ms.state, ms.district, ms.postal_code) END AS supplierAddress, farm.name as supplierCode, CASE WHEN gi.broker > 0 THEN msb.name
    ELSE ms.name END AS supplierName  FROM `+ rmGrnItemsTable + ` gi
    LEFT JOIN `+ mastersFarmsTable + ` farm ON farm.farm_id=gi.farmer_code 
    LEFT JOIN `+ mastersSuppluierTable + ` ms ON ms.supplier_id=gi.farmer 
    LEFT JOIN `+ mastersSuppluierTable + ` msb ON msb.supplier_id=gi.broker 
    where  gi.lot_number='`+ req.lotNumber + `'`;
    const grnData = await manager.query(query);
    if (grnData?.length) {
      const data = grnData.find((val) => val.lotNumber == req.lotNumber)
      return new CommonResponse(true, 5, 'GRN data retreived', data)
    } else {
      return new CommonResponse(false, 5, 'Not Found')
    }
  }

  // async getAllGrn(): Promise<AllGrnResponseModel> {
  //   // const page: number = 1;
  //   try {
  //     const GrnDtos: GrnData[] = [];
  //     //retrieves all companies
  //     const GrnEntities: Grn[] = await this.grnRepository.find({ order: { 'grnDate': 'DESC' } });
  //     //console.log(statesEntities);
  //     if (GrnEntities.length === 0) {
  //       throw new ErrorResponse(10000, 'No Records Found');
  //     }
  //     for (const grn of GrnEntities) {
  //       const masterResponse: MasterInfoFromIndentResponse = await this.supplierService.getMastersRelatedDataFromIndent(new MasterInfoFromIndentRequest(grn.farmer, grn.farmerCode, 1, 1, 1));
  //       const farmer = await this.supplierService.getSupplierBySupplierId({ farmerId: grn.farmer })
  //       const farmerCode = await this.supplierService.getFarmerDetailsByFarmerId({ farmerId: grn.farmerCode })

  //       const indentNumber = await this.indentService.getIndentDetailsById({ indentId: grn.indentId })
  //       console.log('indentNumber' + indentNumber)
  //       const indentCode = indentNumber.status ? indentNumber.data.indentCode : "";
  //       GrnDtos.push(new GrnData(grn.grnDate, grn.indentId, grn.supplierType, grn.farmer, grn.farmerCode, grn.quantity, grn.count, grn.price, grn.createdUser, grn.isActive, grn.grnNumber, grn.grnId, grn.lotNumber, grn.saleOrderId, grn.saleOrderItemId, farmer.status?farmer.data.supplierName:"", indentCode, farmer.status?farmer.data.supplierCode:"", grn.boxes, grn.plantId, grn.subPlantId, grn.updatedUser, grn.assignToRm, grn.softPercentage, grn.receivedBoxes, '', grn.isVInspectionCompleted, grn.isRmInspectionCompleted))
  //     }

  //     return new AllGrnResponseModel(true, 1, 'Grn retrieved successfully', GrnDtos);
  //     // if (GrnEntities) {
  //     //   // converts the data fetched from the database which of type companies array to type StateDto array.
  //     //   GrnEntities.forEach(GrnEntity => {
  //     //     const convertedGrnDto: GrnDTO = this.grnAdapter.convertEntityToDto(
  //     //       GrnEntity
  //     //     );
  //     //     GrnDtos.push(convertedGrnDto);
  //     //   });
  //     //   const response = new AllGrnResponseModel(true,1,'Grn retrieved successfully',GrnDtos);
  //     //   return response;
  //     // } else {
  //     //   throw new ErrorResponse(99998, 'Data not found');
  //     // }

  //   } catch (err) {
  //     return err;
  //   }
  // }
  async getAllActiveGrn(): Promise<AllGrnResponseModel> {
    // const page: number = 1;
    try {
      const GrnDtos: GrnDTO[] = [];
      //retrieves all companies
      const GrnEntities: Grn[] = await this.grnRepository.find({
        order: { 'grnNumber': 'ASC' }, where: { isActive: true },
      });
      console.log(GrnEntities)
      if (GrnEntities) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        GrnEntities.forEach(countriesEntity => {
          const convertedGrnDtos: GrnDTO = this.grnAdapter.convertEntityToDto(
            countriesEntity
          );
          GrnDtos.push(convertedGrnDtos);
        });
        const response = new AllGrnResponseModel(true, 11108, "Grn retrieved successfully", GrnDtos);
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }
  // async updateReceivedBoxes(receivedBoxes: ReceivedBoxes): Promise<GrnResponseModel> {
  //   try {
  //     const updateReceivedBoxes = await this.grnRepository.update(
  //       { grnId: receivedBoxes.grnId },
  //       { receivedBoxes: receivedBoxes.receivedBoxes });
  //     if (updateReceivedBoxes.affected) {
  //       const grnResponse: GrnResponseModel = new GrnResponseModel(true, 10115, 'Grn received boxes updated successfully');
  //       return grnResponse;
  //     } else {
  //       const grnResponse: GrnResponseModel = new GrnResponseModel(false, 10110, 'something went wrong, failed to update.');
  //       return grnResponse;
  //     }
  //   }
  //   catch (err) {
  //     return err;
  //   }
  // }
  async activateOrDeactivateGrn(grnReq: GrnRequest): Promise<GrnResponseModel> {
    try {
      const grnExists = await this.getGrnById(grnReq.grnId);
      if (grnExists) {
        if (grnReq.versionFlag !== grnExists.versionFlag) {
          throw new ErrorResponse(10113, 'Someone updated the current grn information.Refresh and try again');
        } else {

          const grnStatus = await this.grnRepository.update(
            { grnId: grnReq.grnId },
            { isActive: grnReq.isActive, updatedUser: grnReq.updatedUser });

          if (grnExists.isActive) {
            if (grnStatus.affected) {
              const grnResponse: GrnResponseModel = new GrnResponseModel(true, 10115, 'Grn is de-activated successfully');
              return grnResponse;
            } else {
              throw new ErrorResponse(10111, 'Grn is already deactivated');
            }
          } else {
            if (grnStatus.affected) {
              const GrnResponse: GrnResponseModel = new GrnResponseModel(true, 10114, 'Grn is activated successfully');
              return GrnResponse;
            } else {
              throw new ErrorResponse(10112, 'Grn is already  activated');
            }
          }
          // }
        }
      } else {
        throw new ErrorResponse(99998, 'No Records Found');
      }
    } catch (err) {
      return err;
    }
  }
  // async getActiveGrnById(grnReq: GrnRequest): Promise<GrnResponseModel> {
  //   try {
  //     //retrieves all companies
  //     const grnEntities: Grn = await this.grnRepository.findOne({
  //       where: { grnId: grnReq.grnId }
  //     });

  //     if (!grnEntities) {
  //       throw new ErrorResponse(10000, 'No Records Found');
  //     }
  //     const masterResponse: MasterInfoFromIndentResponse = await this.supplierService.getMastersRelatedDataFromIndent(new MasterInfoFromIndentRequest(grnEntities.farmer, grnEntities.farmerCode, 1, 1, 1));
  //     const farmer = await this.supplierService.getSupplierBySupplierId({ farmerId: grnEntities.farmer })
  //     const farmerCode = await this.supplierService.getFarmerDetailsByFarmerId({ farmerId: grnEntities.farmerCode })

  //     const indentNumber = await this.indentService.getIndentDetailsById({ indentId: grnEntities.indentId })
  //     const subPlantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: grnEntities.subPlantId });
  //     const grnObj = new GrnData(grnEntities.grnDate, grnEntities.indentId, grnEntities.supplierType, grnEntities.farmer, grnEntities.farmerCode, grnEntities.quantity, grnEntities.count, grnEntities.price, grnEntities.createdUser, grnEntities.isActive, grnEntities.grnNumber, grnEntities.grnId, grnEntities.lotNumber, grnEntities.saleOrderId, grnEntities.saleOrderItemId, masterResponse.data.farmerName, indentNumber.data.indentCode, masterResponse.data.farmerCode, grnEntities.boxes, grnEntities.plantId, grnEntities.subPlantId, grnEntities.updatedUser, grnEntities.assignToRm, grnEntities.softPercentage, grnEntities.receivedBoxes, subPlantDetails.status ? subPlantDetails.data.unitcodeName : "")

  //     return new GrnResponseModel(true, 1, 'Grn retrieved successfully', grnObj);
  //     // generating resposnse
  //   } catch (err) {
  //     return err;
  //   }
  // }

  async getGrnById(grnId: number): Promise<Grn> {
    //  console.log(employeeId);
    const Response = await this.grnRepository.findOne({
      where: { grnId: grnId },
    });
    // console.log(employeeResponse);
    if (Response) {
      return Response;
    } else {
      return null;
    }
  }

  async getSaleOrdersHavingLotCodes(plantId: number): Promise<SaleOrderDropDownResponseModel> {
    try {
      const manager = getManager();
      const query = `SELECT rm.sale_order_id as saleOrderId FROM ` + appSettings.rm_procure_db + `.grn_items rm Left Join grn g on g.grn_id=rm.grn_id where g.plant_id=` + plantId;
      const lotCodes: any[] = await manager.query(query);
      console.log(lotCodes);
      const response: SaleOrderDropDownDto[] = []
      for (const item of lotCodes) {
        const SoDetails = await this.saleOrderService.getSaleOrderDetailsForId({ saleOrderId: item.saleOrderId });
        if (SoDetails != undefined) {
          const data = new SaleOrderDropDownDto(SoDetails.saleOrderId, SoDetails.saleOrderNumber, SoDetails.poNumber);
          response.push(data);
        }
      }
      if (response.length > 0) {
        return new SaleOrderDropDownResponseModel(true, 1001, "Sale Orders Retrived Successfully", response);
      }
      else {
        return new SaleOrderDropDownResponseModel(false, 1010, "No data found. ", response);
      }
    } catch (err) {
      return err;
    }
  }
  async getLotCodesBySoIdAndSoItemId(req: LotCodesRequest): Promise<LotCodesResponseModel> {
    try {
      const manager = getManager();
      const response: LotCodesDTO[] = []
      const query = `SELECT rm.lot_number as lotNumber,rm.sale_order_id as saleOrderId FROM ` + appSettings.rm_procure_db + `.grn_items rm 
      where rm.sale_order_id=`+ req.saleOrderId + ` and rm.sale_order_item_id=` + req.saleOrderItemId;

      const lotCodes = await manager.query(query);
      console.log(lotCodes);
      if (lotCodes.length > 0) {
        for (const item of lotCodes) {
          console.log(item);

          const poNumber = await this.saleOrderService.getSaleOrderDetailsForId({ saleOrderId: item.saleOrderId });
          const data = new LotCodesDTO(item.lotNumber, poNumber.poNumber != undefined ? poNumber.poNumber : "");
          response.push(data);
        }
        return new LotCodesResponseModel(true, 11101, 'lot codes retrieved Successfully', response);
      }
      else {
        return new LotCodesResponseModel(false, 99998, 'Data not found', response);
      }
    } catch (err) {
      return err;
    }
  }

  async getLotCodesBySoIdAndSoItemIdOld(lotCodesRequest: LotCodesRequest): Promise<LotCodesResponseModel> {
    try {
      //retrieves all companies
      const lotCodes: LotCodesDTO[] = [];
      const grnEntities: GrnItems[] = await this.grnItemRepository.find({
        where: { saleOrderId: lotCodesRequest.saleOrderId, saleOrderItemId: lotCodesRequest.saleOrderItemId, grnInfo: Raw((alias) => `plant_id = '${lotCodesRequest.plantId}'`) }
      });

      if (grnEntities.length > 0) {
        grnEntities.forEach(grnEntity => {
          const grnData = new LotCodesDTO(grnEntity.lotNumber, "");
          lotCodes.push(grnData);
        });
        const response = new LotCodesResponseModel(true, 11101, 'Grn retrived Successfully', lotCodes);
        return response;
      }

      else {
        throw new ErrorResponse(99998, 'Data not found');
      }
      // generating resposnse
    } catch (err) {
      return err;
    }
  }

  async assignToRMTest(grnDto: GrnDTO, isUpdate: boolean): Promise<GrnResponseModel> {
    try {
      const prodInvDto = await new ProdData();
      //  prodInvDto.grnNumber = grnDto.grnNumber;
      prodInvDto.lotNumber = grnDto.lotNumber;
      prodInvDto.saleOrderId = grnDto.saleOrderId;
      prodInvDto.saleOrderItemId = grnDto.saleOrderItemId;
      prodInvDto.physicalQuantity = grnDto.quantity;
      prodInvDto.inputGrade = grnDto.count;
      prodInvDto.boxes = grnDto.boxes;
      prodInvDto.plantId = grnDto.plantId;
      prodInvDto.subPlantId = grnDto.subPlantId;
      prodInvDto.weighmentReq = GlobalStatus.NO;
      prodInvDto.operation = OperationTypeEnum.GRN;
      prodInvDto.nextOperation = OperationTypeEnum.BE_HEADING;
      prodInvDto.status = FgStatusEnum.OPEN;
      prodInvDto.createdUser = grnDto.createdUser;

      const prodInv = await this.prodInvService.createProdInv(prodInvDto);
      if (prodInv.status) {
        // generating resposnse
        const lotCodeOpsDto = await new LotCodeData();
        lotCodeOpsDto.grnDate = grnDto.grnDate;
        lotCodeOpsDto.indentId = grnDto.indentId;
        lotCodeOpsDto.grnNumber = grnDto.grnNumber;
        lotCodeOpsDto.lotNumber = grnDto.lotNumber;
        lotCodeOpsDto.saleOrderId = grnDto.saleOrderId;
        lotCodeOpsDto.saleOrderItemId = grnDto.saleOrderItemId;
        lotCodeOpsDto.supplierType = grnDto.supplierType;
        lotCodeOpsDto.farmer = grnDto.farmer;
        lotCodeOpsDto.farmerCode = grnDto.farmerCode;
        lotCodeOpsDto.count = grnDto.count;
        lotCodeOpsDto.quantity = grnDto.quantity;
        lotCodeOpsDto.price = grnDto.price;
        lotCodeOpsDto.boxes = grnDto.boxes;
        lotCodeOpsDto.plantId = grnDto.plantId;
        lotCodeOpsDto.subPlantId = grnDto.subPlantId;
        lotCodeOpsDto.createdAt = grnDto.createdAt;
        lotCodeOpsDto.createdUser = grnDto.createdUser;

        const lotCodeOps = await this.lotCodeOpsService.createLotCodeOps(lotCodeOpsDto)


        const prodLogDto = await new ProductionLogDto();
        let today = new Date();
        let CurrentYear = today.getFullYear();
        let CurrentMonth = today.getMonth();
        let fromDate = 0;
        let toDate = 0;
        let totalRecords = await (await this.grnRepository.find({ where: { assignToRm: true } })).length;
        if (CurrentMonth < 4) {
          fromDate = (CurrentYear);
          toDate = (CurrentYear + 1);
        } else {
          fromDate = (CurrentYear);
          toDate = (CurrentYear + 1);
        }

        totalRecords = totalRecords + 1;

        var refNo = totalRecords + "";
        while (refNo.length < 4) refNo = "0" + refNo;

        const grnJobNo = "GRN/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;
        prodLogDto.lotNumber = grnDto.lotNumber;
        prodLogDto.saleOrderId = grnDto.saleOrderId;
        prodLogDto.saleOrderItemId = grnDto.saleOrderItemId;
        prodLogDto.plantId = grnDto.plantId;
        prodLogDto.subPlantId = grnDto.subPlantId;
        prodLogDto.inputGrade = grnDto.count;
        prodLogDto.inputQuantity = grnDto.quantity;
        prodLogDto.inputBoxes = grnDto.boxes;
        prodLogDto.operationType = OperationTypeEnum.GRN;
        prodLogDto.createdUser = grnDto.createdUser;
        prodLogDto.jobNumber = grnJobNo;

        const prodLog = await this.prodLogService.createProdLog(prodLogDto);

        if (prodInv) {
          // const updateInv = await this.grnRepository.update(
          //   { grnId: Raw((alias) => `grn_id = '${grnDto.grnId}'`) },
          //   { assignToRm: true }
          // );

          const response = new GrnResponseModel(true, 1, 'RM Received Successfully');

          return response
        } else {
          throw new ErrorResponse(11106, 'RM Received but issue while transforming into DTO');
        }
      } else {
        throw new ErrorResponse(11106, 'Failed To Receive RM Please Try again after some time');
      }

    } catch (error) {
      return error;
    }
  }


  async assignToRM(grnDto: any, isUpdate: boolean): Promise<CommonResponse> {
    console.log(grnDto, 'ass rm')
    const manager = new GenericTransactionManager();
    try {

      await manager.startTransaction();
      let totalGrnItems = await this.grnItemRepository.count({ where: { lotNumber: isNotEmpty(null) } })
      let today = new Date();
      let CurrentYear = today.getFullYear();
      let CurrentMonth = today.getMonth();
      let fromDate = 0
      let toDate = 0

      if ((CurrentMonth + 1) < 4) {
        fromDate = (CurrentYear);
        toDate = (CurrentYear);
      } else {
        fromDate = (CurrentYear);
        toDate = (CurrentYear + 1);

      }

      totalGrnItems = totalGrnItems + 1;
      // let grnItemRefNo = totalGrnItems + "";
      let grnItemRefNo = grnDto.refNo + "";
      let subPlantShortCode = ''
      let result
      if (grnDto.subPlantId > 0) {
        result = await this.unitCodesService.getPlantDetailsById(new PlantIdRequest(grnDto.subPlantId))
        if (result.data.plantType == UnitTypeEnum.SUB_PLANT) {
          subPlantShortCode = "-" + result.data.shortKey
        }
      }
      while (grnItemRefNo.length < 4) grnItemRefNo = "0" + grnItemRefNo;
      console.log('itemssss');
      console.log(grnItemRefNo)
      const lotNo = "LOT" + "-" + (grnDto.plantId === 1 ? 'KKD' : grnDto.plantId === 2 ? 'U1' : grnDto.plantId === 3 ? 'U2' : '') + "/" + (toDate.toString().substr(-2)) + '/' + (today.getMonth() + 1) + "/" + grnItemRefNo + subPlantShortCode;

      const updateInv = await manager.getCustomRepository(GrnItemRepository).update(
        { grnId: Raw((alias) => `grn_item_id = '${grnDto.grnItemId}'`) },
        { assignToRm: true, receivedBoxes: grnDto.receivedBoxes, lotNumber: lotNo }
      );
      let prodInv;
      if (updateInv.affected) {
        const grnInfo = await new GrnInformationDto();
        grnInfo.grnDate = grnDto.grnDate;
        grnInfo.indentId = grnDto.indentId;
        grnInfo.grnNumber = grnDto.grnNumber;
        grnInfo.lotNumber = lotNo;
        grnInfo.saleOrderId = grnDto.saleOrderId;
        grnInfo.saleOrderItemId = grnDto.saleOrderItemId;
        grnInfo.supplierType = grnDto.supplierType;
        grnInfo.farmer = grnDto.farmer;
        grnInfo.farmerCode = grnDto.farmerCode;
        grnInfo.count = grnDto.count;
        grnInfo.quantity = grnDto.quantity;
        grnInfo.price = grnDto.price;
        grnInfo.boxes = grnDto.receivedBoxes;
        grnInfo.plantId = grnDto.plantId;
        grnInfo.remarks = grnDto.remarks
        if (grnDto.subPlantId > 0) {
          grnInfo.subPlantId = grnDto.subPlantId;
        } else {
          grnInfo.subPlantId = 0;
        }
        grnInfo.createdAt = grnDto.createdAt;
        grnInfo.createdUser = grnDto.createdUser;
        console.log(grnInfo);
        console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@')
        prodInv = await this.prodInvService.createGrnInventory(grnInfo);
        console.log(prodInv);
        if (prodInv.status) {
          manager.completeTransaction();
          const response = new CommonResponse(true, 1, 'RM Received Successfully');
          return response;
        } else {
          throw new ErrorResponse(11106, 'Failed To Update Inventory');
        }

      } else {
        throw new ErrorResponse(11106, 'Failed To Receive RM');
      }
    } catch (error) {
      console.log(error)
      await manager.releaseTransaction();
      throw error;
    }
  }

  async getAllLotCodes(plant: PlantIdRequest): Promise<LotCodesResponseModel> {
    return new LotCodesResponseModel(false, 1010, "No data found. ",);
    // try {
    //   const response: LotCodesDTO[] = [];
    //   const getAllLotCodes = await this.grnRepository.createQueryBuilder("Grn").where("plant_id =" + plant.unitcodeId).groupBy("lot_number").getMany();
    //   for (const grn of getAllLotCodes) {
    //     const data = new LotCodesDTO(grn.lotNumber);
    //     response.push(data);
    //   }
    //   if (getAllLotCodes.length > 0) {
    //     return new LotCodesResponseModel(true, 1001, "Lot Codes Retrived successfully. ", response);
    //   }
    //   else {
    //     return new LotCodesResponseModel(false, 1010, "No data found. ",);
    //   }

    // } catch (error) {
    //   return error;
    // }
  }
  async getAllSaleOrders(plant: PlantIdRequest): Promise<SaleOrderDropDownResponseModel> {
    return new SaleOrderDropDownResponseModel(false, 1010, "No data found. ",);
    // try {
    //   const response: SaleOrderDropDownDto[] = [];
    //   const getAllSaleOrders = await this.grnRepository.createQueryBuilder("Grn").where("plant_id =" + plant.unitcodeId).andWhere('sale_order_id IS NOT NULL').groupBy("sale_order_id").getMany();
    //   for (const grn of getAllSaleOrders) {
    //     const getSaleOrderNo = await this.saleOrderService.getSaleOrderInformation({ saleOrderId: grn.saleOrderId });
    //     const data = new SaleOrderDropDownDto(grn.saleOrderId, getSaleOrderNo.data.saleOrderNumber);
    //     response.push(data);
    //   }
    //   if (getAllSaleOrders.length > 0) {
    //     return new SaleOrderDropDownResponseModel(true, 1001, "SaleOrders Retrived successfully. ", response);
    //   }
    //   else {
    //     return new SaleOrderDropDownResponseModel(false, 1010, "No data found. ",);
    //   }

    // } catch (error) {
    //   return error;
    // }
  }


  async getRmVehicleGrnById(grnReq: GrnRequest): Promise<RMVehicleInfoResponse> {
    return new RMVehicleInfoResponse(true, 1, 'Grn retrieved successfully', undefined)
    // try {
    //   //retrieves all companies
    //   const grnEntities: Grn = await this.grnRepository.findOne({
    //     where: { grnId: grnReq.grnId }
    //   });
    //   if (!grnEntities) {
    //     throw new ErrorResponse(10000, 'No Records Found');
    //   }
    //   console.log(grnEntities);
    //   const masterResponse: MasterInfoFromIndentResponse = await this.supplierService.getMastersRelatedDataFromIndent(new MasterInfoFromIndentRequest(grnEntities.farmer, grnEntities.farmerCode, 1, 1, 1));
    //   // const farmer = await this.supplierService.getSupplierBySupplierId({ farmerId: grnEntities.farmer })
    //   // const farmerCode = await this.supplierService.getFarmerDetailsByFarmerId({ farmerId: grnEntities.farmerCode })

    //   const indentNumber = await this.indentService.getIndentDetailsById({ indentId: grnEntities.indentId })
    //   const subPlantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: grnEntities.subPlantId });
    //   const vehicleInfo = await this.vehicleAssignmentService.getVehicleAssignDetailsByIndentId({ indentId: grnEntities.indentId });
    //   const vehicleData = await this.vehicleService.getVehicleByVehId({ vehicleId: vehicleInfo.data.vehicleId });
    //   const harvestData = await this.harvestreportService.getHarvestReport({plantId:grnEntities.plantId,harvestId:grnEntities.indentId})
    //   console.log(harvestData)

    //   const grnVehiclInfo = new GrnVehicleInfo();
    //   grnVehiclInfo.rmGrnId = grnReq.grnId;
    //   grnVehiclInfo.rmGrnNumber = grnEntities.grnNumber;
    //   grnVehiclInfo.indentId = grnEntities.indentId;
    //   grnVehiclInfo.indentNumber = indentNumber.data.indentCode;
    //   grnVehiclInfo.supplierId = 0;
    //   grnVehiclInfo.supplierCode = masterResponse.data.farmerCode;
    //   grnVehiclInfo.supplierAddress = masterResponse.data.address;
    //   grnVehiclInfo.vehicleId = vehicleInfo.data.vehicleId;
    //   grnVehiclInfo.vehicleNumber = vehicleData.data.registrationNumber;
    //   grnVehiclInfo.productId = indentNumber.data.product;
    //   grnVehiclInfo.varietyOfMaterial = indentNumber.data.productCode;
    //   grnVehiclInfo.sealNumber = harvestData.data.sealNo


    //   return new RMVehicleInfoResponse(true, 1, 'Grn retrieved successfully', grnVehiclInfo);
    // } catch (err) {
    //   return err;
    // }
  }

  async getGrnInfoByItemId(req: RMGrnItemIdReq): Promise<RMVehicleInfoResponse> {
    try {
      const manager = getManager();
      const query = `SELECT g.grn_id as rmGrnId, gi.grn_item_id as rmGrnItemId,g.indent_no as indentId, gi.farmer as supplierId, veh.vehicle_id as vehicleId, gi.product as productId, indent_code as indentNumber, rmvi_number as rmVINumber, g.grn_number as rmGrnNumber, mp.name as varietyOfMaterial, har.vehicle_no as vehicleNumber, vehicle_in_time as vehicleInTime, har.seal_no as sealNumber, icing_condition as icingConditionOfMaterial, crates_condition as cratesCondition, cleanliness_Of_crates as cleanlinessOfCrates, vehicle_cleanliness as vehicleCleanliness, sign_of_infestation as anySignOfInfestation, dust_or_filth as contaminationDustOrFilth, insulation_damage as insulationDamage, rmVi.remarks as remarks, g.plant_id as plantId, rmVi.created_user as createdUser, rmVi.updated_user as updatedUser, rmVi.inspection_id as inspectionId, gi.lot_number as lotNumber, CASE WHEN gi.broker > 0 THEN CONCAT_WS(", ", msb.street, msb.apartment, msb.city, msb.state, msb.district, msb.postal_code)
      ELSE CONCAT_WS(", ",ms.street, ms.apartment, ms.city, ms.state, ms.district, ms.postal_code) END AS supplierAddress, farm.name as supplierCode  FROM `+ rmGrnItemsTable + ` gi
      LEFT JOIN `+ rmGrnTable + ` g ON g.grn_id=gi.grn_id 
      LEFT JOIN `+ rmIndentTable + ` i ON i.indent_id=g.indent_no 
      LEFT JOIN `+ rmVIInspection + ` rmVi ON rmVi.grn_item_id=gi.grn_item_id 
      LEFT JOIN `+ mastersFarmsTable + ` farm ON farm.farm_id=gi.farmer_code 
      LEFT JOIN `+ mastersSuppluierTable + ` ms ON ms.supplier_id=gi.farmer 
      LEFT JOIN `+ mastersProductsTable + ` mp ON mp.product_id=gi.product
      LEFT JOIN `+ mastersSuppluierTable + ` msb ON msb.supplier_id=gi.broker 
      LEFT JOIN `+ mastersEmployeeTable + ` me ON me.employee_id=i.assign_lead_1
      LEFT JOIN `+ mastersEmployeeTable + ` mem ON mem.employee_id=i.assign_lead_2
      LEFT JOIN `+ rmVehicleAssignment + ` veh ON veh.indent_id=g.indent_no
      LEFT JOIN `+ harvesting + ` har ON har.indent_item_id=gi.indent_item_id
      LEFT JOIN `+ salesSoTable + ` s ON s.sale_order_id=gi.sale_order_id
      LEFT JOIN `+ salesInvTable + ` inv ON inv.sale_order_id=gi.sale_order_id 
      where  gi.grn_item_id=`+ req.grnItemId;
      const grnData: GrnVehicleInfo[] = await manager.query(query);
      if (grnData) {
        const grnItem: GrnVehicleInfo = grnData.find((val) => val.rmGrnItemId === req.grnItemId);
        return new RMVehicleInfoResponse(true, 1, 'Grn retrieved successfully', grnItem)
      } else {
        throw new ErrorResponse(99999, 'Not Found');
      }
    } catch (error) {
      return error;
    }
  }


  async getRmGrnDataById(req: GrnRequest) {
    const manager = getManager();

    const query = `SELECT CONCAT(gi.lot_number,IF(gi.remarks IS NOT NULL ,"-",""),IF(gi.remarks IS NOT NULL,gi.remarks,"")) AS lotnplantlot,s.sale_order_no as saleOrderNo,inv.po_number as poNumber,gi.assign_to_rm as assignToRm,g.grn_id as grnId,gi.lot_number as lotNumber,gi.boxes,gi.received_boxes as receivedBoxes,gi.soft_percentage as softPercentage,g.grn_date as grnDate,g.grn_number as grnNumber,i.assign_lead_1 as assignLead1,i.supplier_type as supplierType,i.vehicle_assigned as vehicleAssigned,i.assign_lead_2 as assignLead12,i.commission,i.commission_type as commissionType,i.created_user as createdUser,i.grn_completed as grnCompleted,i.harvesting_date as harvestingDate,i.harvesting_time as harvestingTime,i.indent_code as indentCode,i.indent_date as indentDate,i.indent_id as indentId,g.plant_id as plantId,g.sub_plant_id as subPlantId,gi.product,gi.farmer,gi.count,gi.farmer_code as farmerCode,gi.grn_item_id as grnItemId,gi.indent_item_id as indentItemId,gi.sale_order_id as saleOrderId,gi.sale_order_item_id as saleOrderItemId,gi.quantity,gi.price ,farm.name as farmName,farm.address as farmAddress,ms.name as farmerName,msb.name as brokerName,mp.name as productName,me.employee_name as lead1Name,mem.employee_name as lead2Name, gi.vi_inspection as isVInspectionCompleted, gi.rm_inspection as isRmInspectionCompleted, gi.antibiotic_test as isAntibioticsTestCompleted,gi.loose_shell as looseShell,fungus_percentage as fungusPercentage,gi.remarks as plantLotNumber,gi.ref_no as refNo,i.harvest_type as harvestType FROM ` + rmGrnTable + ` g 
    LEFT JOIN `+ rmGrnItemsTable + ` gi ON gi.grn_id=g.grn_id 
    LEFT JOIN `+ rmIndentTable + ` i ON i.indent_id=g.indent_no 
    LEFT JOIN `+ mastersFarmsTable + ` farm ON farm.farm_id=gi.farmer_code 
    LEFT JOIN `+ mastersSuppluierTable + ` ms ON ms.supplier_id=gi.farmer 
    LEFT JOIN `+ mastersProductsTable + ` mp ON mp.product_id=gi.product
    LEFT JOIN `+ mastersSuppluierTable + ` msb ON msb.supplier_id=gi.broker 
    LEFT JOIN `+ mastersEmployeeTable + ` me ON me.employee_id=i.assign_lead_1
    LEFT JOIN `+ mastersEmployeeTable + ` mem ON mem.employee_id=i.assign_lead_2
    LEFT JOIN `+ salesSoTable + ` s ON s.sale_order_id=gi.sale_order_id
    LEFT JOIN `+ salesInvTable + ` inv ON inv.sale_order_id=gi.sale_order_id 
    
    where  g.grn_id=`+ req.grnId;
    const grnData = await manager.query(query);
    return new CommonResponse(true, 1001, 'GRN data retrieved successfully', grnData);
  }

  async updatePlantOrSubPlant(grnRequest: RmGrnPlantRequest): Promise<CommonResponse> {
    const manager = new GenericTransactionManager();
    try {

      await manager.startTransaction();
      const updateInv = await manager.getCustomRepository(GrnRepository).update(
        { grnId: Raw((alias) => `grn_id = '${grnRequest.grnId}'`) },
        { plantId: grnRequest.plantId, subPlantId: grnRequest.subPlantId }
      );
      if (updateInv.affected) {
        manager.completeTransaction()
        return new CommonResponse(true, 1, 'Updated successfully', undefined)
      } else {
        manager.releaseTransaction()
        return new CommonResponse(false, 0, 'not updated', undefined)

      }
    } catch (err) {
      manager.releaseTransaction()
      return new CommonResponse(false, 0, 'not updated', undefined)
    }
    return
  }
  async getGRNAbstract(grnAbstractRequest: GrnAbstractRequest): Promise<any> {
    console.log(new Date(grnAbstractRequest.fromDate));
    const manager = getManager();
    const query = `SELECT If(u.unit_name is null,"Out Side",u.unit_name) AS unit_name,
    SUM(CASE WHEN COUNT BETWEEN 0 AND 25 THEN quantity ELSE 0 END) AS count25,
    SUM(CASE WHEN COUNT BETWEEN 26 AND 32 THEN quantity ELSE 0 END) AS count30,
    SUM(CASE WHEN COUNT BETWEEN 33 AND 42 THEN quantity ELSE 0 END) AS count40,
    SUM(CASE WHEN COUNT BETWEEN 43 AND 52 THEN quantity ELSE 0 END) AS count50,
    SUM(CASE WHEN COUNT BETWEEN 53 AND 62 THEN quantity ELSE 0 END) AS count60,
    SUM(CASE WHEN COUNT BETWEEN 63 AND 72 THEN quantity ELSE 0 END) AS count70,
    SUM(CASE WHEN COUNT BETWEEN 73 AND 82 THEN quantity ELSE 0 END) AS count80,
    SUM(CASE WHEN COUNT BETWEEN 83 AND 92 THEN quantity ELSE 0 END) AS count90,
    SUM(CASE WHEN COUNT BETWEEN 93 AND 102 THEN quantity ELSE 0 END) AS count100,
    SUM(CASE WHEN COUNT BETWEEN 103 AND 112 THEN quantity ELSE 0 END) AS count110,
    SUM(CASE WHEN COUNT BETWEEN 113 AND 122 THEN quantity ELSE 0 END) AS count120,
    SUM(CASE WHEN COUNT BETWEEN 123 AND 132 THEN quantity ELSE 0 END) AS count130,
    SUM(CASE WHEN COUNT BETWEEN 133 AND 500 THEN quantity ELSE 0 END) AS count140
    FROM grn_items LEFT JOIN grn g ON g.grn_id=grn_items.grn_id 
    LEFT JOIN erpx_dev_masters.unitcodes u ON u.unit_code_id=g.plant_id      
    GROUP BY u.unit_code_id`;

    console.log(query);
    let grnAbstract = await manager.query(query);
    return new AllGrnResponseModel(true, 5555, 'closed indents retrived', grnAbstract)
  }

  async updateGrnAuditQty(req: RmActualCountDto) {
    const updateResponse = await this.grnItemRepository.update({ grnItemId: req.grnItemId }, { actualCount: req.actualCount, actualQuantity: req.actualQuantity });

    if (updateResponse.affected) {
      return new CommonResponse(true, 1111, 'Updated Successfully.');
    } else {
      return new CommonResponse(false, 9999, 'Failed To Update.')
    }
  }
}

